import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatRelativeTime } from '../../utils/dateFormatter';
import './EmailList.css';

function EmailList({ emails, loading, error }) {
  const navigate = useNavigate();

  const handleEmailClick = (email) => {
    navigate(`/email/${email.tracking_id}`);
  };

  const getStatusIcon = (email) => {
    if (email.read_count > 0 || email.status === 'read') {
      return <span className="status-icon green">✓</span>;
    }
    return <span className="status-icon gray">✓</span>;
  };

  const getStatusText = (email) => {
    if (email.read_count > 0 || email.status === 'read') {
      const count = email.read_count || 1;
      return `Read ${count} time${count > 1 ? 's' : ''}`;
    }
    return 'Not read yet';
  };

  // Use imported date formatter (automatically handles user's timezone)
  const formatDate = (dateString) => {
    if (!dateString) return 'Recently';
    try {
      return formatRelativeTime(dateString);
    } catch (error) {
      return 'Recently';
    }
  };

  if (loading) {
    return (
      <div className="email-list-loading">
        <div className="spinner"></div>
        <p>Loading emails...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="email-list-error">
        <span className="error-icon">⚠️</span>
        <h3>Error Loading Emails</h3>
        <p>{error}</p>
      </div>
    );
  }

  if (!emails || emails.length === 0) {
    return (
      <div className="email-list-empty">
        <span className="empty-icon">📧</span>
        <h3>No Tracked Emails Yet</h3>
        <p>Emails you send from Gmail will appear here once tracked.</p>
        <div className="empty-steps">
          <h4>Get Started:</h4>
          <ol>
            <li>Make sure the Chrome extension is installed</li>
            <li>Open Gmail and compose a new email</li>
            <li>Send the email with tracking enabled</li>
            <li>Come back here to see tracking status</li>
          </ol>
        </div>
      </div>
    );
  }

  return (
    <div className="email-list">
      <div className="email-list-header">
        <h2>Tracked Emails ({emails.length})</h2>
      </div>

      <div className="email-list-items">
        {emails.map((email) => (
          <div
            key={email.id || email.tracking_id}
            className="email-item"
            onClick={() => handleEmailClick(email)}
          >
            <div className="email-item-icon">
              {getStatusIcon(email)}
            </div>

            <div className="email-item-content">
              <div className="email-item-subject">
                {email.subject || '(No subject)'}
              </div>
              <div className="email-item-recipient">
                To: {email.recipient}
              </div>
            </div>

            <div className="email-item-meta">
              <div className="email-item-status">
                {getStatusText(email)}
              </div>
              <div className="email-item-date">
                {formatDate(email.sent_at)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EmailList;
